export default {
  label: 'Origem',
  items: {
    listening: 'Social Listening',
    sac: 'Métricas Proprietárias',
    smartCare: 'Smart Care',
    competitive: 'Competitivo',
  },
};
